import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import logo from "../assets/images/luth-logo-192.png";
import logo1 from "../assets/images/luth-logo-16x16.png";
import logoprint from "../assets/images/luth-logo-small.png";

export default function PrintPage({ biodata }) {
  const printRef = useRef();
  const institutions = biodata?.institutions || [];
  const exams = biodata?.exams || [];
  const documents = biodata?.documents || [];

  // Determine if JAMB section should display
  const jambEligibleProgrammes = [
    "Department of Nursing Sciences",
    "Department of Nursing Sciences",
    "School of Health Information Management (ND)",
    "Biomedical Engineering (ND)",
  ];
  const showJamb = jambEligibleProgrammes.includes(biodata?.programme);

  useEffect(() => {
    // wait for render then print
    setTimeout(() => {
      window.print();
      window.close();
    }, 500);
  }, []);

  // format DOB
  const formatDate = (dStr) => {
    if (!dStr) return "";
    const d = new Date(dStr);
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  };

  return (
    <div ref={printRef} className="print-area">
      <img src={logo1} alt="Watermark" className="watermark" />

      <div className="print-header">
        <img src={logoprint} alt="Logo Print" className="logo-print" />
        <div className="print-header-text">
          <div className="print-title">
            <h2>LAGOS UNIVERSITY TEACHING HOSPITAL, (LUTH) IDI-ARABA, LAGOS</h2>
          </div>
          <div className="print-subtitle">
            <h3>APPLICANT BIODATA FORM</h3>
          </div>
        </div>
        {biodata.passportUrl && (
          <img
            src={biodata.passportUrl}
            alt="Passport Print"
            className="passport-print"
          />
        )}
      </div>

      <div className="prog-appno">
        <div
          style={{
            float: "right",
            fontWeight: "bold",
            fontSize: "2rem",
            color: "silver",
            textShadow: "1px 1px 2px rgba(0, 0, 0, 0.3)",
            border: "2px solid silver",
            padding: "0.5rem 1rem",
            borderRadius: "10px",
            background: "linear-gradient(135deg, #f0f0f0, #d9d9d9)",
            display: "inline-block",
          }}
        >
          {new Date().getFullYear()}
        </div>
        <p>
          <strong>School:</strong> {biodata.programme}
        </p>
        <p>
          <strong>
            Application No: {biodata.applicationNo || biodata.ApplicationNo}
          </strong>
        </p>
      </div>

      {/* Personal & JAMB side by side */}
      <div className="print-row">
        <div>
          <div className="section-title">Personal Information</div>
          <table>
            <tbody>
              <tr>
                <td>Surname</td>
                <td>{biodata.LastName}</td>
              </tr>
              <tr>
                <td>First Name</td>
                <td>{biodata.FirstName}</td>
              </tr>
              <tr>
                <td>Middle Name</td>
                <td>{biodata.MiddleName}</td>
              </tr>
              <tr>
                <td>Gender</td>
                <td>{biodata.Gender}</td>
              </tr>
              <tr>
                <td>DOB</td>
                <td>{formatDate(biodata.DateOfBirth)}</td>
              </tr>
              <tr>
                <td>Phone</td>
                <td>{biodata.PhoneNumber || biodata.Phone}</td>
              </tr>
              <tr>
                <td>Email</td>
                <td>{biodata.Email}</td>
              </tr>
            </tbody>
          </table>
        </div>
        {showJamb && (
          <div>
            <div className="section-title">JAMB Details</div>
            <table>
              <tbody>
                <tr>
                  <td>Reg No</td>
                  <td>{biodata.JambRegNumber || biodata.JambRegNo}</td>
                </tr>
                <tr>
                  <td>Year</td>
                  <td>{biodata.JambYear}</td>
                </tr>
                <tr>
                  <td>Exam No</td>
                  <td>{biodata.JambExamNumber || biodata.JambExamNo}</td>
                </tr>
                <tr>
                  <td>Score</td>
                  <td>{biodata.JambScore}</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Institutions & Exams side by side */}
      <div className="print-row">
        <div>
          <div className="section-title">Institutions Attended</div>
          {institutions.length ? (
            <table>
              <thead>
                <tr>
                  <td>Name</td>
                  <td>Qualification</td>
                  <td>Years</td>
                </tr>
              </thead>
              <tbody>
                {institutions.map((inst, i) => (
                  <tr key={i}>
                    <td>{inst.InstitutionName}</td>
                    <td>{inst.QualificationObtained}</td>
                    <td>
                      {inst.StartYear} - {inst.EndYear}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>No institutions recorded.</p>
          )}
        </div>
        <div>
          <div className="section-title">Exams Passed</div>
          {exams.length ? (
            exams.map((exam, i) => (
              <div key={i}>
                <p>
                  <strong>
                    {exam.ExamName}{" "}
                    {exam.Sittings ? `(Sitting ${exam.Sittings})` : ""}
                  </strong>
                </p>
                <table>
                  <tbody>
                    {Object.entries(exam.SubjectsAndGrades || {}).map(
                      ([sub, gr]) => (
                        <tr key={sub}>
                          <td>{sub}</td>
                          <td>{gr}</td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>
              </div>
            ))
          ) : (
            <p>No exams passed.</p>
          )}
        </div>
      </div>

      <p className="note">
        <strong>Note:</strong>
        <br />
        1. Kindly come with the biodata form to the exam hall.
        <br />
        2. Bags and electronic devices are not allowed in the exam hall.
        <br />
        3. All Exams hold the same day.
        <br />
        4. If you miss the exam, you will not be rescheduled.
      </p>
    </div>
  );
}

PrintPage.propTypes = {
  biodata: PropTypes.object.isRequired,
};
